<template>
  <tr class="el-table__row">
    <td :style="leftWidth">
      <div class="cell">
        <div v-html="label"></div>
      </div>
    </td>
    <td :style="rightWidth">
      <div class="cell">
        <slot>
          {{ value }}
        </slot>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'KeyValueTableRow',

  inject: ['KeyValueTable'],

  props: {
    label: {
      required: false
    },
    value: {
      required: false
    }
  },

  computed: {
    leftWidth() {
      return { width: this.KeyValueTable.leftWidth + '%' }
    },

    rightWidth() {
      return { width: this.KeyValueTable.rightWidth + '%' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/table/KeyValueTableRow.vue